import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdmwcuja4d: FaireProductEntity = {
  token: "p_cdmwcuja4d",
  type: "product",
  name: "Cool Down Performance Body Spray",
  brandToken: "b_evrq835k7x",
  brandName: "Touchland",
  imageUrl: "https://cdn.faire.com/fastly/16251f1a9a160f94f304e29feb8ddf782f34b278cb600e97e960a92fec07b707.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8435ae2934831d91cb7cfbe0bfba6989299c4a8fb18a42e2c2e9d6857e413ea0.jpeg",
    "https://cdn.faire.com/fastly/654cd3e63f7d08cbd356bb74be30eb0295c408962b9e9f06fbe4c834cde84d84.jpeg",
    "https://cdn.faire.com/fastly/504e662082464546719cc2752748e845230b8d1626025b51b9b19b7fe0b21ee2.png",
    "https://cdn.faire.com/fastly/8e8d63821bc5d455039a11eb1e9a7a1989ec840429282ba652410f773eac7b67.png"
  ],
  priceDollars: 10,
  description: "A long-lasting Performance Body Spray with built-in skincare and an odor-eliminating formula that refreshes, hydrates, and keeps you feeling fresh on the move.\n\nCool Down Fragrance: A cool pulse of orange flower and fresh-cut ginger settles into calming cedarwood, grounding you in clarity.\n\nTop Notes: Violet Leaf, Salted Mineral Water, Italian Bergamot\nHeart Notes: Ginger, Sage, Orange Flower\nBase Notes: Amber, Vetiver, Cedarwood\n\nMain Ingredients:\n- Hyaluronic acid: Helps hydrate and improve skin’s appearance.\n- Panthenol: Helps smooth and refresh skin and hair.\n- Niacinamide: Helps boost radiance of skin and hair.\n\nBenefits:\n- Infused with hyaluronic acid, niacinamide, and panthenol to leave skin and hair hydrated, refreshed, and smooth.\n- Odor-neutralizing.\n- Lightweight, long-lasting fragrance\n- Free of parabens, phthalates, sulfates, and mineral oils. \n- Dermatologically tested.\n- Layerable scent. \n- Travel-friendly 2 FL. OZ. (60 mL)",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:35.638Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
